import { useState } from 'react';
import { Sparkles, X, ChevronDown, Database, Lightbulb, ShieldAlert, CheckCircle } from 'lucide-react';

// 通用页面级 AI 引导悬浮入口（演示版）
// 真实版由本实例超级智能体读"字段元数据 + 已填值"动态生成；此处用预置 hints 演示形态。
const KIND = {
  explain: { label: '解释', icon: Database, cls: 'bg-blue-50 border-blue-200 text-blue-700', dot: 'text-blue-500' },
  recommend: { label: '推荐', icon: Lightbulb, cls: 'bg-amber-50 border-amber-200 text-amber-700', dot: 'text-amber-500' },
  fact: { label: '事实型', icon: ShieldAlert, cls: 'bg-gray-50 border-gray-200 text-gray-600', dot: 'text-gray-400' },
};

export default function PageAiGuide({ pageName, hints = [] }) {
  const [open, setOpen] = useState(false);
  const [adopted, setAdopted] = useState({});

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-2">
      {open && (
        <div className="w-[22rem] bg-white border border-gray-200 rounded-2xl shadow-xl flex flex-col overflow-hidden" style={{ maxHeight: 440 }}>
          <div className="flex items-center justify-between px-4 py-3 bg-gradient-to-r from-blue-600 to-indigo-600">
            <div className="flex items-center gap-2"><Sparkles className="w-4 h-4 text-white" /><span className="text-sm font-semibold text-white">AI 引导 · {pageName}</span></div>
            <button onClick={() => setOpen(false)} className="p-1 hover:bg-white/10 rounded text-white"><X className="w-4 h-4" /></button>
          </div>
          <div className="px-4 py-2 bg-indigo-50 border-b border-indigo-100">
            <p className="text-xs text-indigo-600 leading-relaxed">基于<strong>本页字段元数据 + 已填值</strong>动态生成（演示）。事实型字段只解释、经验型参数可推荐值。</p>
          </div>
          <div className="flex-1 overflow-y-auto p-3 space-y-2 bg-gray-50">
            {hints.map((hAuto, i) => {
              const m = KIND[hAuto.kind] || KIND.explain;
              const Icon = m.icon;
              return (
                <div key={i} className={`text-xs leading-relaxed p-2.5 rounded-lg border ${m.cls}`}>
                  <div className="flex items-center gap-1.5 mb-1">
                    <Icon className={`w-3.5 h-3.5 ${m.dot}`} />
                    <span className="font-medium">{m.label}</span>
                    {hAuto.field && <span className="px-1.5 py-0.5 rounded bg-white/60 text-[10px]">{hAuto.field}</span>}
                  </div>
                  <div>{hAuto.text}</div>
                  {hAuto.kind === 'recommend' && (
                    <div className="mt-2 flex items-center gap-2">
                      <span className="text-[11px] opacity-70">推荐 <strong>{hAuto.value}</strong></span>
                      {adopted[i]
                        ? <span className="text-[11px] text-green-600 flex items-center gap-0.5"><CheckCircle className="w-3 h-3" /> 已采纳</span>
                        : <button onClick={() => setAdopted(p => ({ ...p, [i]: true }))} className="text-[11px] px-2 py-0.5 bg-amber-500 text-white rounded hover:bg-amber-600">采纳推荐值</button>}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
      <button onClick={() => setOpen(v => !v)} className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-600 to-indigo-600 shadow-lg flex items-center justify-center hover:scale-105 transition-transform">
        {open ? <ChevronDown className="w-5 h-5 text-white" /> : <Sparkles className="w-5 h-5 text-white" />}
      </button>
    </div>
  );
}
